var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 22,
    viewBox: "0 0 16 16",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.68701 1.26145c-.3855-.36447-.98852-.36447-1.37402 0l-4.84351 4.57934c-.29968.28334-.46948.67756-.46948 1.08997v5.56924c0 .8284.67157 1.5 1.5 1.5h1.5c.82843 0 1.5-.6716 1.5-1.5v-2.5c0-.27611.22386-.49997.5-.49997h2c.27614 0 .5.22386.5.49997v2.5c0 .8284.6716 1.5 1.5 1.5h1.5c.8284 0 1.5-.6716 1.5-1.5v-5.56924c0-.41241-.1698-.80663-.4695-1.08997z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/homeFilled.9a660f843a1eca0429961a05aab06a86.svg";
export { ForwardRef as ReactComponent };